export * from "./locales.js";
import type { Locale } from "./locales.js";

export type Messages = Record<string, string>;

/** Kataloge werden je Sprache nachgeladen (eigene Chunks im Web-Build). */
const loaders: Record<Locale, () => Promise<{ default: Messages }>> = {
  de: () => import("../messages/de.json"),
  en: () => import("../messages/en.json"),
  tr: () => import("../messages/tr.json"),
  ar: () => import("../messages/ar.json"),
  ru: () => import("../messages/ru.json"),
  uk: () => import("../messages/uk.json"),
  pl: () => import("../messages/pl.json"),
  ro: () => import("../messages/ro.json"),
  it: () => import("../messages/it.json"),
  es: () => import("../messages/es.json"),
  fr: () => import("../messages/fr.json"),
  fa: () => import("../messages/fa.json"),
};

export async function loadMessages(locale: Locale): Promise<Messages> {
  return (await loaders[locale]()).default;
}
